import type { ParagraphBlock } from "../../../services/educationService";
import styles from "./article.module.css";

export function ArticleParagraph({ block }: { block: ParagraphBlock }) {
	return <p className={styles.paragraph}>{block.text}</p>;
}
